import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { colors } from '../../constants'

// eslint-disable-next-line import/prefer-default-export
export const Inline = styled.div`
    display: inline-block;
    vertical-align: middle;
    ${({ first }) => !first && ' margin-left: 3px;'}
    font-size: 12px;
`

export const CircleIcon = styled(FontAwesomeIcon)`
    ${({ color }) => (color ? `color: ${color};` : `color: ${colors.greylightest}7F;`)}
`
